import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';
import { FpLoggerNoiseLeakScoreChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/services/fp-logger-noise-leak-score-chart.service';
import { FpLoggerNoiseLeakScoreConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/services/fp-logger-noise-leak-score-connect.service';
import { FpLoggerNoiseLeakScoreExportService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/services/fp-logger-noise-leak-score-export.service';
import { FpLoggerNoiseLeakScoreStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/services/fp-logger-noise-leak-score/fp-logger-noise-leak-score.store';

export function fpLoggerNoiseLeakScoreProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoiseLeakScoreChartService,
    FpLoggerNoiseLeakScoreExportService,
    FpLoggerNoiseLeakScoreStore,
    FpLoggerNoiseLeakScoreConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoiseLeakScoreConnectService,
      multi: true,
    },
  ];
}
